import { tva } from "@gluestack-ui/utils/nativewind-utils";

// `status` is set only on a remote image's frame: the placeholder tile shows
// until the image loads. The caller's className is merged last, so a caller
// `bg-*` (dark poster areas, chat bubbles) keeps its own background.
export const imageStyle = tva({
  base: "max-w-full",
  variants: {
    size: {
      "2xs": "h-6 w-6",
      xs: "h-10 w-10",
      sm: "h-16 w-16",
      md: "h-20 w-20",
      lg: "h-24 w-24",
      xl: "h-32 w-32",
      "2xl": "h-64 w-64",
      full: "h-full w-full",
      none: "",
    },
    status: {
      loading: "overflow-hidden bg-background-50",
      failed: "overflow-hidden bg-background-50",
      loaded: "overflow-hidden",
    },
  },
});

// `animate-pulse` is a CSS animation on web and a Reanimated 4 CSS animation
// on native, through the react-native-css-interop patch in `.yarn/patches/`.
export const placeholderStyle = tva({
  base: "absolute inset-0 items-center justify-center",
  variants: {
    status: {
      loading: "animate-pulse",
      failed: "",
    },
  },
});

export const HORIZON_SUN_CLASS =
  "absolute right-[18%] top-[18%] rounded-full bg-typography-400 opacity-40";

export const HORIZON_HILLS_CLASS =
  "absolute bottom-0 left-0 h-[42%] w-full text-typography-400";
